/**
 * Web3 钱包工具模块
 * 支持 Trust Wallet dApp 浏览器、PC 浏览器插件（MetaMask 等）
 */

/**
 * 检查是否有钱包插件 / dApp 浏览器注入
 */
export function hasWallet() {
    return typeof window !== 'undefined' && window.ethereum
}

/**
 * 连接钱包并获取地址
 * @returns {Promise<string>} 钱包地址
 */
export async function connectWallet() {
    if (!hasWallet()) {
        throw new Error('Please open it using the built-in browser of Trust Wallet or install the MetaMask plugin')
    }
    try {
        const accounts = await window.ethereum.request({
            method: 'eth_requestAccounts'
        })
        if (!accounts || accounts.length === 0) {
            throw new Error('Wallet address not obtained')
        }
        return accounts[0]
    } catch (err) {
        if (err.code === 4001) {
            throw new Error('The user refused the connection request')
        }
        throw err
    }
}

/**
 * 用钱包签名消息（EIP-191 personal_sign）
 * @param {string} message 待签名消息
 * @param {string} address 钱包地址
 * @returns {Promise<string>} 签名 hex
 */
export async function signMessage(message, address) {
    if (!hasWallet()) {
        throw new Error('Please open it using the built-in browser of Trust Wallet or install the MetaMask plugin')
    }
    try {
        const signature = await window.ethereum.request({
            method: 'personal_sign',
            params: [message, address]
        })
        return signature
    } catch (err) {
        if (err.code === 4001) {
            throw new Error('The user refused the signature request')
        }
        throw err
    }
}

/**
 * 获取当前已连接的钱包地址
 * @returns {Promise<string|null>}
 */
export async function getConnectedAddress() {
    if (!hasWallet()) {
        return null
    }
    try {
        const accounts = await window.ethereum.request({
            method: 'eth_accounts'
        })
        return accounts && accounts.length > 0 ? accounts[0] : null
    } catch {
        return null
    }
}

/**
 * 监听账户变更
 * @param {Function} callback
 */
export function onAccountsChanged(callback) {
    if (hasWallet()) {
        window.ethereum.on('accountsChanged', callback)
    }
}

/**
 * 监听链变更
 * @param {Function} callback
 */
export function onChainChanged(callback) {
    if (hasWallet()) {
        window.ethereum.on('chainChanged', callback)
    }
}
